import React, { useState, useRef, useEffect , useCallback} from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import {CDBSidebar,CDBSidebarContent,CDBSidebarMenu,CDBSidebarMenuItem,} from 'cdbreact';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { Lightbox } from "react-modal-image";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { utils, writeFile } from 'xlsx-js-style';
import customFetch from './customFetch';
import readXlsxFile from 'read-excel-file'


let user = null;
let ALLOWED_CITIES_NAME_TO_ID = {};
let ALLOWED_COMPANIES_NAME_TO_ID = {};

let ALLOWED_CITIES_ID_TO_NAME = {};
let ALLOWED_COMPANIES_ID_TO_NAME = {};

let ALLOWED_VALUES_CITY = [];
let ALLOWED_VALUES_COMPANY = [];

let PAYLOAD = null;
let PRO_CLIENT = null;
let TOKEN = null;
let IS_ADMIN = null;
let IS_SYSTEM = null;

async function loadCitiesCompanies() {
  if (ALLOWED_CITIES_NAME_TO_ID.length > 0) return;

  let pro_cities = await customFetch("/api/pro-cities", {
    method: "GET",
    headers: {'authorization': TOKEN}
  });
  pro_cities = await pro_cities.json();
  let allowed_values_city = [];
  for (let r of pro_cities) {
    if (true) {
      allowed_values_city.push(r.name_ru);
      ALLOWED_CITIES_NAME_TO_ID[r.name_ru] = r.id;
      ALLOWED_CITIES_ID_TO_NAME[r.id] = r.name_ru;
    }
  }


  let pro_companies = await customFetch("/api/pro-companies", {
    method: "GET",
    headers: {'authorization': TOKEN}
  });
  pro_companies = await pro_companies.json();
  let allowed_values_company = [];
  for (let r of pro_companies) {
	try {

    if (true) {
      allowed_values_company.push(r.name_ru);
      ALLOWED_COMPANIES_NAME_TO_ID[r.name_ru] = r.id;
      ALLOWED_COMPANIES_ID_TO_NAME[r.id] = r.name_ru;
    }


	} catch (e) {}

  }
  ALLOWED_VALUES_CITY = allowed_values_city;
  ALLOWED_VALUES_COMPANY = allowed_values_company;
}

function toLocalDatetime(isoTimestamp) {
  const date = new Date(isoTimestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');  
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}`;
}

function hasNonNullValue(obj) {
  for (const key in obj) {
    if (obj[key] !== null) {
      return true;
    }
  }
  return false;
}

function safeNumber(s) {
  s = isNaN(Number(s)) ? 0 : Number(s)
  if (s < 0) return 0;
  return s;
}

function safeString(s) {
  if (s === null || s === undefined) return "";
  return String(s);
}

function parseImagesArr(arr) {
  for (let i of arr) {
    let dateObj = new Date(i.timestamp)
    const utcOffsetMs = (+3) * 60 * 60 * 1000;
    dateObj.setTime(dateObj.getTime() + utcOffsetMs);

    if (i.pro_city in ALLOWED_CITIES_ID_TO_NAME) {
      i.pro_city = ALLOWED_CITIES_ID_TO_NAME[i.pro_city]
    }

    if (i.pro_company in ALLOWED_COMPANIES_ID_TO_NAME) {
      i.pro_company = ALLOWED_COMPANIES_ID_TO_NAME[i.pro_company]
    }

    i.timestamp = toLocalDatetime(i.timestamp)
    if (i.ai_label && hasNonNullValue(i.ai_label)) {
      for (let kk in i.ai_label) {
        i[kk] = i.ai_label[kk]
      }
    }
    if (i.user_label && hasNonNullValue(i.user_label)) {
      for (let kk in i.user_label) {
        i[kk] = i.user_label[kk]
      }
    }

    if (!i.url) {
      i.url = 'https://offline.proanalytics.net/'
    }
    if (i.loaded) {
      continue;
    }
  }
  return arr;
}

const Admin = () => {
  const navigate = useNavigate();

    try {
      const user = JSON.parse(localStorage.getItem("user"))
      if (!user || !user.token) {
        navigate("/")
      }
      PAYLOAD = JSON.parse(atob(user.token.split('.')[1]));
      PRO_CLIENT = PAYLOAD.pro_client
      IS_ADMIN = PAYLOAD.is_admin
      IS_SYSTEM = PAYLOAD.is_system
      TOKEN  = user.token
    } catch (e) {
      navigate("/")
      console.log(e)
    }
    


    const sidebarRef = useRef(null); 
    const gridRef = useRef(null);

    const fileInputRef = useRef(null);

  

    const [colDefs, setColDefs] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchDataOnce, setFetchDataOnce] = useState(false);
    const [defaultColDef, setDefaultColDef] = useState({});

    const [activeItem, setActiveItem] = useState("images");
    

    const [firstLoad, setFirstLoad] = useState(true);


    const handleFileChange = (event) => {
      const selectedFile = event.target.files[0];
      if (!selectedFile) {
        return;
      }
  
      if (selectedFile.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
          selectedFile.type !== 'application/vnd.ms-excel') {
        return;
      }
  

      const reader = new FileReader();
  
      reader.onload = async (e) => {
        try {
          console.log("isloading+")
          setIsLoading(true);
          const fileContent = e.target.result;
          console.log('File content loaded:', fileContent);
          let rows = await readXlsxFile(fileContent, {
              parseNumber: (string) => string
            }
          );
          if (rows.length <=1) return;
          let loginCol = null;
          let passCol = null;
          for (let i = 0; i<rows[0].length; i++) {
            if (rows[0][i].toLowerCase() === 'логин') {
              loginCol = i;
            }
            if (rows[0][i].toLowerCase() === 'пароль') {
              passCol = i;
            }
          }
          if (loginCol === null) {
            alert('Нет колонки "Логин"')
            return;
          }
          if (passCol === null) {
            alert('Нет колонки "Пароль"')
            return;
          }
          let grid_rows = [];
          for (let i = 1; i<rows.length;i++) {
            grid_rows.push({
              login: rows[i][loginCol],
              new_password: rows[i][passCol],
          })
          }
          await gridRef.current.api.applyTransaction({
            add: grid_rows,
          });
          await saveTable();


        } catch (err) {
          console.log(`Error reading file: ${err.message}`);
          console.error("Error reading file:", err);
        } finally {
          console.log("isloading-")
          setIsLoading(false);
        }
      };
  
      reader.onerror = (err) => {
        console.log(`Error reading file: ${err}`);
        console.error("File reader error:", err);
      };
  
      // Choose the appropriate read method based on how you want to process the file
      // reader.readAsText(selectedFile);     // For text-based files
      reader.readAsArrayBuffer(selectedFile); // For binary files (like XLSX), often used with SheetJS
      // reader.readAsDataURL(selectedFile);  // For displaying images, etc.  (Not suitable for XLSX processing)
    };



    const handleItemClick = (itemKey) => {
        setIsLoading(false);
        setFetchDataOnce(false);
        setColDefs([]);
        setRowData([]);
        setDefaultColDef({});
        setActiveItem(itemKey);
    };

   


    const [userList, setUserList] = useState([]);
    const [shopList, setShopList] = useState([]);

    const [uploadFiles, setUploadFiles] = useState(false);
    const [uploadUser, setUploadUser] = useState(false);
    const [uploadShop, setUploadShop] = useState(false);

    const [clientLogoUrl, setClientLogoUrl] = useState("");

    
    const userListOptions = (userList && userList.length > 0 ? userList.map((item) => {
      return (
        <option key={item.value} value={item.value}>{item.name}</option>
      )
    }) : []);

    const shopListOptions = (shopList && shopList.length > 0 ? shopList.map((item) => {
      return (
        <option key={item.value} value={item.value}>{item.name}</option>
      )
    }) : []);


    const adminLogout = () => {
      localStorage.removeItem("user")
      navigate("/")
  }

  const addRow = () => {
    gridRef.current.api.applyTransaction({
      add: [{}],
    });
  }


  const saveTable = async () => {
    let allRows = [];
    gridRef.current.api.forEachNode((rowNode, index) => {
      if (activeItem === "companies") {
        if (rowNode.data.pro_city in ALLOWED_CITIES_NAME_TO_ID) {
          rowNode.data.pro_city = ALLOWED_CITIES_NAME_TO_ID[rowNode.data.pro_city]
        }
        if (rowNode.data.pro_company in ALLOWED_COMPANIES_NAME_TO_ID) {
          rowNode.data.pro_company = ALLOWED_COMPANIES_NAME_TO_ID[rowNode.data.pro_company]
        }
      }
      allRows.push(rowNode.data);
    });

    try {
      setIsLoading(true)
      let r = await customFetch("/api/"+activeItem, {
        method: "POST",
        headers: {'authorization': TOKEN, 'content-type': 'application/json'},
        body: JSON.stringify(allRows)
      });
      await r.json();
    } catch (e) {
      alert(e)
    } finally {
      setIsLoading(false)
      setFetchDataOnce(false);
    } 
  }
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [modalImage, setModalImage] = useState(''); 

  const imgRender =  function(params) {
    const srcPreview = "/api/static/thumbnail/"+params.data.thumbnail;
  return (<img alt={'thumbnail'} src={srcPreview} style={{width: 'auto', height: '50px'}}></img>);
  }

  const priceRender =  function(params) {
    if (safeNumber(params.data.price) === 0) return params.data.price;
    return Number(params.data.price).toLocaleString('en-US').replaceAll(',',' ')
  }

  const linkRender =  function(params) {
    if (safeString(params.data.url) === "") return null;
    return (<a href={params.data.url} title={params.data.url}>{params.data.url}</a>);
  }

  const multilineRender =  function(params) {
    return (<div>
        {params.value.split("\n").map((i,key) => {
            return <div key={key}>{i}</div>;
        })}
    </div>);
  }

  const linkMapRender =  function(params) {
    return (<a target="_blank" rel="noreferrer" href={"https://yandex.com/maps/?mode=search&text="+params.value} title={"Показать на карте"}>{JSON.stringify(params.value)}</a>);
  }

  const withTitle =  function(params) {
    const s = safeString(params.value)
    return (<div title={s}>{s}</div>);
  }

  const colorIfFake =  function(params) {
    const s = safeString(params.value)
    if (params.data.coordinates_faked) {
      return (<div style={{color: '#4ebf6d'}} title={s}>{s}</div>);
    } else {
      return (<div title={s}>{s}</div>);
    }
  }

  
  const removeSelectedRows = () => {
    if (activeItem !== 'images') {
      const selectedRowData = gridRef.current.api.getSelectedRows();
      gridRef.current.api.applyTransaction({ remove: selectedRowData });
    } else {
      const selectedRowData = gridRef.current.api.getSelectedRows();
      if (selectedRowData.length >0) {
        setOpenModalDelete(true);
      }
    }
  }

  async function updateLabel(jsonArr) {
    try {
      setIsLoading(true);
      await customFetch("/api/label", {
        method: "POST",
        headers: {'authorization': TOKEN, 'content-type': 'application/json'},
        body: JSON.stringify(jsonArr)
      });
    } catch (e) {alert(e)} 
    finally {
      setIsLoading(false);
    }
  }

  const onRowValueChanged = useCallback((event) => {
    if (activeItem === 'images') {
      const data = event.data;
      const jsonArr = {
        _id: data._id,
        name: data.name,
        price: data.price,
        article: data.article,
      }
      updateLabel(jsonArr)
    }
}, [activeItem]);






const onCellClicked = useCallback((event) => {
  if (activeItem === 'images' &&  event.colDef.field === 'img') {
    let srcBig = "/api/static/image/"+event.data.image;
    if (event.data.polygon && event.data.polygon.length == 8) {
      srcBig +='?polygon='+event.data.polygon.join();
    }
    setModalImage(srcBig);
    setOpenModal(true);
  }
}, [activeItem]);

    useEffect(() => {

      if (firstLoad) {



        if (PRO_CLIENT > 0) {
          setClientLogoUrl(`https://api.4monitoring.ru/resources/companies/logo-${PRO_CLIENT}.png`)
        }


        handleItemClick(activeItem);
        setFirstLoad(false);
      }
      if (activeItem === "images" && !isLoading && !fetchDataOnce) {
        setIsLoading(true);
        setDefaultColDef({
          flex: 1,
          editable: false,
          cellDataType: false
      })
        setColDefs([
          { headerName: "Фото", field: "img", cellRenderer: imgRender, width: 90, flex: false, sortable: false},
          { headerName: "Время", field: "timestamp", width: 170, flex: false, cellDataType: 'text', filter: "agTextColumnFilter",sort: "desc"},
          { headerName: "User", field: "user", width: 90, flex: false, cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Компания", field: "pro_company", width: 120, flex: false, cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Город", field: "pro_city",  width: 150, flex: false, cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Адрес", field: "address" , cellRenderer: colorIfFake , cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Название", field: "name", cellRenderer: withTitle,editable: true, cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Артикул", field: "article", cellRenderer: withTitle, editable: true, width: 140, flex: false, cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Цена", field: "price", cellRenderer: priceRender, editable: true, width: 100, flex: false, cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Ссылка", field: "url", cellRenderer: linkRender, editable: false, width: 110, flex: false, cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Отправ", field: "loaded",editable: false, width: 110, flex: false, cellDataType: 'boolean', filter: "agTextColumnFilter"},
        ]);


        (async () => {
          await loadCitiesCompanies()
          let r = null;
          try {
            r = await customFetch("/api/images", {
              method: "GET",
              headers: {'authorization': TOKEN}
            });
            r = await r.json();
            r = parseImagesArr(r);
          

            {
              let r = await customFetch("/api/companies", {
                method: "GET",
                headers: {'authorization': TOKEN}
              });
              let shops = [{value: '0', name: 'Выберите...'}];
              for (let c of await r.json()) {
                shops.push({value: c.coordinates, name: c.company+' '+c.city+' '+c.address});
              }
              setShopList(shops);
            }

            {
              let r = await customFetch("/api/users", {
                method: "GET",
                headers: {'authorization': TOKEN}
              });
              let users = [{value: 0, name: 'Выберите...'}];
              for (let u of await r.json()) {
                users.push({value: u._id, name: u.login});
              }
              setUserList(users);
            }

          } catch (e) {
            r = null;
              console.log(e);
          } finally {
              setFetchDataOnce(true);
              setIsLoading(false);
              if (r) {
                // setInterval(() => {
                //   let t = gridRef.current.api.getFilterModel();
                //   console.log(t)
                // }, 1111)
                  setRowData(r);
                  gridRef.current.api.setFilterModel({
                    "loaded": {
                        "filterType": "text",
                        "type": "false"
                    }
                });
              }
          }
        })();
      }
      if (activeItem === "companies" && !isLoading && !fetchDataOnce) {
        setIsLoading(true);
        setDefaultColDef({
          flex: 1,
          editable: true,
          cellDataType: false
        })

        setColDefs([]);

  
        (async () => {
          await loadCitiesCompanies();
          
          setColDefs([
            { headerName: "[Город]", field: "pro_city",cellDataType: 'text',filter: "agTextColumnFilter", width: 200, flex: false, cellEditor: "agSelectCellEditor", 
              cellEditorParams: {values: ALLOWED_VALUES_CITY}
            },
            { headerName: "[Компания]", field: "pro_company",cellDataType: 'text',filter: "agTextColumnFilter", width: 200, flex: false, cellEditor: "agSelectCellEditor",
              cellEditorParams: {values: ALLOWED_VALUES_COMPANY}
            },
            { headerName: "Адрес", field: "address" ,filter: "agTextColumnFilter"},
            { headerName: "Координаты", field: "coordinates" , cellRenderer: linkMapRender},
          ]);



          let r = null;
          try {
            r = await customFetch("/api/companies", {
              method: "GET",
              headers: {'authorization': TOKEN}
            });
            r = await r.json();
          } catch (e) {
              r = null;console.log(e);
          } finally {
              setFetchDataOnce(true);
              setIsLoading(false);
              if (r) {
                  for (let row of r) {
                    if (row.pro_city in ALLOWED_CITIES_ID_TO_NAME) {
                      row.pro_city = ALLOWED_CITIES_ID_TO_NAME[row.pro_city]
                    }
                    if (row.pro_company in ALLOWED_COMPANIES_ID_TO_NAME) {
                      row.pro_company = ALLOWED_COMPANIES_ID_TO_NAME[row.pro_company]
                    }
                  }
                  setRowData(r);
              }
          }
        })();
      }
      if (activeItem === "users" && !isLoading && !fetchDataOnce) {
        setIsLoading(true);
        setDefaultColDef({
          flex: 1,
          editable: true,
          cellDataType: false
      })

        if (IS_SYSTEM) {
          setColDefs([
            { headerName: "Логин", field: "login", filter: "agTextColumnFilter"},
            { headerName: "Новый пароль", field: "new_password", filter: "agTextColumnFilter"},
            { headerName: "Клиент", field: "pro_client", cellDataType: 'number', filter: "agNumberColumnFilter"},
            { headerName: "Админ", field: "is_admin", cellDataType: 'boolean', filter: "agTextColumnFilter", sort: "desc"},
          ]);  
        } else {
          setColDefs([
          { headerName: "Логин", field: "login" },
          { headerName: "Новый пароль", field: "new_password" },
          ]);
        }
        (async () => {
          let r = null;
          try {
            r = await customFetch("/api/users", {
              method: "GET",
              headers: {'authorization': TOKEN}
            });
            r = await r.json();
          } catch (e) {
              r = null;console.log(e);
          } finally {
              setFetchDataOnce(true);
              setIsLoading(false);
              if (r) {
                  setRowData(r);
              }
          }
        })();
      }
      if (activeItem === "report" && !isLoading && !fetchDataOnce) {
        setIsLoading(true);
        setDefaultColDef({
          editable: false,
          cellDataType: false
      })
        setColDefs([
          { headerName: "Дата", field: "date", width: 120, cellDataType: 'text', filter: "agTextColumnFilter", sort: "desc"},
          { headerName: "Пользователь", field: "user", width: 220, cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Магазины", cellRenderer: multilineRender, autoHeight:true, field: "shops", flex: 1 , cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Распознано", field: "ai_ok", width: 130, cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Не распознано", field: "ai_fail", width: 150 , cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Вручную", field: "ai_user", width: 120 , cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Очередь", field: "ai_queue", width: 120 , cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Всего", field: "total", width: 100 , cellDataType: 'number', filter: "agNumberColumnFilter"},
        ]);
  
        (async () => {
          let r = null;
          try {
            r = await customFetch("/api/report", {
              method: "GET",
              headers: {'authorization': TOKEN}
            });
            r = await r.json();
          } catch (e) {
              r = null;console.log(e);
          } finally {
              setFetchDataOnce(true);
              setIsLoading(false);
              if (r) {
                  setRowData(r);
              }
          }
        })();
      }


      }, [activeItem, isLoading, fetchDataOnce, firstLoad, navigate]);

    return (
        <div className="mainContainer" style={{ height: '100vh'}}> 
        
        {
          openModal && (
            <Lightbox
              large={modalImage}
              onClose={() => {setOpenModal(false);}}
            />
          )
        }

            <header style={{
                    height: '45px', 
                    width: '100%', 
                    top: 0,
                    backgroundColor: (IS_SYSTEM ? '#e91e63' : '#2dc3e8'), 
                    position: 'absolute',
                    display: 'flex', 
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingRight: '1%',
                    paddingLeft: '1%',
                    }}>
                    <img src="proanalytics.svg" style={{height:'85%'}} alt=""></img>
                    <img src={clientLogoUrl} style={{}} alt=""></img>
                    <FontAwesomeIcon icon={faSignOutAlt} style={{height: '75%'}} color="white"  onClick={adminLogout}/> 
                </header>

                <CDBSidebar ref={sidebarRef}  style={{ position: 'absolute', left: 0, top: 45,  height: 'calc(100vh - 45px)' }} textColor="#333" backgroundColor="#f0f0f0">
      <CDBSidebarContent className="sidebar-content">
        <CDBSidebarMenu>
          <CDBSidebarMenuItem icon="image" onClick={() => handleItemClick('images')} active={activeItem === 'images'}>Работа с фото</CDBSidebarMenuItem>
          <CDBSidebarMenuItem icon="user" onClick={() => handleItemClick('users')} active={activeItem === 'users'}>Пользователи</CDBSidebarMenuItem>
          <CDBSidebarMenuItem icon="building" onClick={() => handleItemClick('companies')} active={activeItem === 'companies'}>Адреса магазинов</CDBSidebarMenuItem>
          <CDBSidebarMenuItem icon="table" onClick={() => handleItemClick('report')} active={activeItem === 'report'}>Отчет</CDBSidebarMenuItem>
        </CDBSidebarMenu>
      </CDBSidebarContent>
    </CDBSidebar>

    <div style={{ backgroundColor: 'white', 
                  position:'absolute', 
                  top:45, left: (sidebarRef.current ? sidebarRef.current.offsetWidth : 0), 
                  width: `calc(100% - ${sidebarRef.current ? sidebarRef.current.offsetWidth : 0}px)`,
                  height: 'calc(100vh - 45px)' }}>

  <div className="ag-theme-quartz" style={{ height: '70%', padding: '10px' }}>
            <AgGridReact 
            loading={isLoading}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            ref={gridRef}
            rowSelection={(activeItem !== 'report' ? {mode: 'multiRow'} : null)}
            editType={'fullRow'}
            onRowValueChanged={onRowValueChanged}
            onCellClicked={onCellClicked}
            enableCellTextSelection={true}
            />
            

            <input
        type="file"
        accept=".xlsx"
        style={{ display: 'none' }}
        onChange={handleFileChange}
        ref={fileInputRef}
      />


            <Button 
            variant="outline-secondary" 
            style={{margin: "5px 10px 5px 0px",width: 'auto',display: (['users'].includes(activeItem) && !IS_SYSTEM ? '' : 'none')}} 
            onClick={() => {
            if (fileInputRef.current) {
                fileInputRef.current.click();
                }
              }
            } 
            title={"Импорт из Excel"}>Импорт из Excel</Button>



            <Button 
            variant="outline-secondary" 
            style={{margin: "5px 5px 5px 0px",width: 'auto',display: (['companies', 'users'].includes(activeItem) ? '' : 'none')}} 
            onClick={addRow} 
            title={"Добавить строку в таблицу"}>Добавить</Button>

            <Button 
            variant="outline-secondary" 
            style={{margin: "5px", width: 'auto',display: (['companies','images', 'users'].includes(activeItem) ? '' : 'none')}} 
            onClick={removeSelectedRows} 
            title={"Удалить выделенные строки"}>Удалить</Button>



            <Button 
            variant="outline-secondary" 
            style={{margin: "5px",width: 'auto',display: (['images'].includes(activeItem) ? '' : 'none')}} 
            onClick={async () => {


              let allRows = [];
              {
                let r = await customFetch("/api/images", {
                  method: "GET",
                  headers: {'authorization': TOKEN}
                });
                r = await r.json();
                allRows = parseImagesArr(r);

              }
              const header_row = ['Время', 'Фото', 'Пользователь', 'Компания', 'Город', 'Адрес', 'Название',  'Артикул', 'Цена','Отправлен в базу'];
                let XLS0 = [];
                XLS0.push(header_row);
                for (let i=0;i<allRows.length;i++) {
                  const r = allRows[i];
                  const xls_row  = [
                    r.timestamp,
                    '',
                    r.user,
                    r.pro_company,
                    r.pro_city,
                    r.address,
                    r.name,
                    r.article,
                    r.price,
                    r.loaded ? 'да' : 'нет'
                  ]
                  XLS0.push(xls_row);
                }
                let wb = utils.book_new();
                let ws = utils.aoa_to_sheet(XLS0);
                
                for (let i=0;i<allRows.length;i++) {
                  const r = allRows[i];

                  let imgUrl = "https://offline.proanalytics.net/api/static/image/"+r.image;
                  if (r.polygon && r.polygon.length == 8) {
                    imgUrl +='?polygon='+r.polygon.join();
                  }
                  const cellAddress = utils.encode_cell({ r: i + 1, c: 1 });
                  ws[cellAddress] = {
                    t: 's',
                    v: 'ссылка',
                    l: {
                      Target: imgUrl,
                      Tooltip: 'Ссылка на фото'
                    }
                  };
                }

                const boldStyle = {
                  font: { bold: true }
                };

                const range = { s: { r: 0, c: 0 }, e: { r: 0, c: header_row.length - 1 } };
                for (let col = range.s.c; col <= range.e.c; col++) {
                  const cellRef = utils.encode_cell({ r: range.s.r, c: col });
                  if (!ws[cellRef]) ws[cellRef] = {};
                  ws[cellRef].s = boldStyle;
                }

                ws['!cols'] = [
                  { wch: 20 },
                  { wch: 10 },
                  { wch: 15 },
                  { wch: 18 },
                  { wch: 15 },
                  { wch: 30 },
                  { wch: 60 },
                  { wch: 35 },
                  { wch: 10 },
                  { wch: 15 },
                ];
                ws['!autofilter'] = { ref: 'A1:J1' };



            let rep = await customFetch("/api/report", {
              method: "GET",
              headers: {'authorization': TOKEN}
            });
            rep = await rep.json();





              const svod = [
                ['Дата', 'Пользователь', 'Магазины', 'Распознано', 'Не распознано', 'Вручную', 'Очередь', 'Всего']
              ];
              for (let r of rep) {
                svod.push(Object.values(r));
              }



              let ws2 = utils.aoa_to_sheet(svod);


              ws2['!cols'] = [
                { wch: 20 },
                { wch: 15 },
                { wch: 60 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
                { wch: 20 },
              ];


              ws2['!rows'] = [{ hpt: 20 }];//{ hpt: 30 }, 
              for (let i=1;i<svod.length;i++) {
                ws2['!rows'].push({ hpt: 20*(svod[i][2].split('\n').length) })
              }

              const range2 = { s: { r: 0, c: 0 }, e: { r: 0, c: svod[0].length - 1 } };
              for (let col = range2.s.c; col <= range2.e.c; col++) {
                const cellRef = utils.encode_cell({ r: range2.s.r, c: col });
                if (!ws2[cellRef]) ws[cellRef] = {};
                ws2[cellRef].s = boldStyle;
              }


              utils.book_append_sheet(wb, ws2, 'Свод');
              utils.book_append_sheet(wb, ws, 'Подробно');



                const filename = Math.random()+'.xlsx';
                writeFile(wb, filename, { compression: true });





            }}
            title="Экспорт в Excel">Экспорт в Excel</Button>

            <Button 
            variant="outline-secondary" 
            style={{margin: "5px",width: 'auto',display: (['companies', 'users'].includes(activeItem) ? '' : 'none')}} 
            onClick={saveTable}
            title="Сохранить изменения">Сохранить</Button>
  </div>

  <br></br>


  <Form onSubmit={ async (e) => {

      e.preventDefault();

      if (uploadFiles.length > 0  &&  uploadShop && uploadShop !== '0') {
        console.log('uploadFiles', uploadFiles);
        console.log('uploadUser:', uploadUser);
        console.log('uploadShop:', uploadShop);

        try {
          setIsLoading(true);
          for (let f of uploadFiles) {
            const formData = new FormData();
            formData.append('file', f);

            formData.append('coordinates', uploadShop);
            formData.append('user', uploadUser);
  
            await customFetch("/api/image", {
              headers: {'authorization': TOKEN},
              method: 'POST',
              body: formData
            })

          }
          setFetchDataOnce(false)
        } catch (e) {          alert(e)} finally {
          setUploadFiles([]);
          setIsLoading(false);
         }


      } else {
        console.log('onSubmit')
      }


  }} style={{display: (activeItem === 'images'? '' : 'none')}}>
  <div style={{display: 'flex',padding: 20, justifyContent: 'center', alignItems: 'center'}}>
  
  <Form.Group >
  <Form.Label>Выбрать фото для добавления</Form.Label>      
        <Form.Control type="file" multiple onChange={(e) => {setUploadFiles(e.target.files)}} />
      </Form.Group>
     


  <Form.Group >
  <Form.Label>Пользователь</Form.Label>     
      
  <Form.Select style={{width: 300}} onChange={(e) => {setUploadUser(e.target.value)}}>{userListOptions}</Form.Select>
    </Form.Group>


    <Form.Group >
  <Form.Label>Адрес магазина</Form.Label>     
      
    <Form.Select style={{width: 300}} onChange={(e) => {setUploadShop(e.target.value)}}>{shopListOptions}</Form.Select>
    </Form.Group>
        </div>

        <div style={{display: 'flex',padding: 20, justifyContent: 'center', alignItems: 'center'}}>
        <Button variant="outline-secondary" style={{width: 300}} type="submit">Добавить</Button>
        </div>
        </Form>




                  </div>

    <div className="modal show" style={{ display: (openModalDelete ? 'block' : 'none'), position: 'initial',backgroundColor:'#aaaaaaa0'}}>
      <Modal.Dialog>
        <Modal.Header closeButton>
          <Modal.Title>Удалить фото?</Modal.Title>
        </Modal.Header>

        <Modal.Footer>
          <Button variant="secondary" onClick={()=>{setOpenModalDelete(false)}}>Нет</Button>
          <Button variant="primary" onClick={ async () =>{
            try {
              setIsLoading(true);
              const selectedRowData = gridRef.current.api.getSelectedRows();
              const _ids = [];
              for (let row of selectedRowData){
                _ids.push({_id: row._id})
              }
              gridRef.current.api.applyTransaction({ remove: selectedRowData });
              let r = await customFetch("/api/image", {
                method: "DELETE",
                headers: {'authorization': TOKEN, 'content-type': 'application/json'},
                body: JSON.stringify(_ids)
              });
              await r.json();
            } catch (e) {alert(e)}
            finally {
              setIsLoading(false);
              setOpenModalDelete(false)
            }
              

              
          }}>Да</Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>

        </div>
        );
}

export default Admin
